import queryString from 'query-string'
import {ANALYSIS_ID} from '../../constant/CookieKeys'
import {getJSON} from '../../api/myaxios'
//将对象转成url 参数
var parseParam=function(param, key){
    var paramStr="";
    if(param instanceof String||param instanceof Number||param instanceof Boolean){
      paramStr+="&"+key+"="+encodeURIComponent(param);
    }else{
      $.each(param,function(i){
        var k=key==null?i:key+(param instanceof Array?"["+i+"]":"."+i);
        paramStr+='&'+parseParam(this, k);
      });
    }
    return paramStr.substr(1);
  };
  
/**
 * param 将要转为URL参数字符串的对象
 * key URL参数字符串的前缀
 * encode true/false 是否进行URL编码,默认为true
 * 
 * return URL参数字符串
 */
var urlEncode = function (param, key, encode) {
  if(param==null) return '';
  var paramStr = '';
  var t = typeof (param);
  if (t == 'string' || t == 'number' || t == 'boolean') {
    paramStr += '&' + key + '=' + ((encode==null||encode) ? encodeURIComponent(param) : param);
  } else {
    for (var i in param) {
      var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);
      paramStr += urlEncode(param[i], k, encode);
    }
  }
  return paramStr;
};

function pad2(n) {
  return n < 10 ? '0' + n : n
}
function yyyyMMddhhmmss() {
  const date = new Date();
  return date.getFullYear().toString() + pad2(date.getMonth() + 1) + pad2(date.getDate()) + pad2(date.getHours()) + pad2(date.getMinutes()) + pad2(date.getSeconds())
}
import axios from 'axios'
import { isApp, isAndroid } from './env';


export function click_event(event_name,$vm) {
  const $vm_init ={
    urlParams:{},
    userInfo:{},
    deviceInfo:{}

  }
  $vm = $vm || $vm_init
  //统计信息
  const source= $vm.urlParams.source ||gact.source
  const userInfo= $vm.userInfo 
  const deviceInfo= $vm.deviceInfo

  const params = {};
  params.uuid = userInfo.uuid || 'unknow';
  params.time = yyyyMMddhhmmss();
  params.act_name = window.rootdata.act_name_chn;
  params.source = source;
  params.uvip = userInfo.vip_id
  params.cookie = gact.analysis_id;
  params.type = 'event';
  params.info = event_name;
  params.mac = deviceInfo.mac || ""
  params.debug = window.gact.debug;
  params.invoker = window.gact.invoker;
  setTimeout(() => {
    axios.get("https:///vip.log.mgtv.com/vipact_event.html" + '?' + urlEncode(params));
  }, 0);
}


export function page_view(page_name,$vm) {
  const $vm_init ={
    urlParams:{},
    userInfo:{},
    deviceInfo:{}

  }
  $vm = $vm || $vm_init
  //统计信息
  const source= $vm.urlParams.source ||gact.source
  const userInfo= $vm.userInfo 
  const deviceInfo= $vm.deviceInfo


  const params = {};
  params.uuid = userInfo.uuid || 'unknow';
  params.time = yyyyMMddhhmmss();
  params.act_name = window.rootdata.act_name_chn;
  params.source = source;
  params.uvip = userInfo.vip_id;
  params.cookie = gact.analysis_id;
  params.type = 'pv';
  params.info = page_name;
  params.mac = deviceInfo.mac || ""
  params.debug = window.gact.debug;
  params.invoker = window.gact.invoker;
  setTimeout(() => {
    axios.get("https:///vip.log.mgtv.com/vipact_event.html" + '?' + queryString.stringify(params));
  }, 0);
}


/**
 * app收银台pv上报
 */
function appCasherPV(clocation,source,userInfo,deviceInfo) {
  const device_info = deviceInfo;
  const params = {
    act: 'vip',
    pagename: 'ACT_D',
    actid: source,
    clocation: clocation,
    uuid: userInfo.uuid,
    time: yyyyMMddhhmmss(),
    mod: device_info.mod,
    ch: device_info.ch,
    sver: device_info.sver,
    gps: device_info.gps,
    mf: device_info.mf,
    did: device_info.did,
    cid: device_info.cid,
    bid: '2.1.1',
    net: device_info.net,
    pver: device_info.pver,
    pix: device_info.pix,
    aver: device_info.aver
  };
  setTimeout(() => {
    axios.get("https:///vip.log.mgtv.com/audit_mpp.html" + '?' + queryString.stringify(params));
  }, 0);
}

/**
 * h5收银台pv上报
 */
function h5CasherPV(clocation,source,userInfo) {
  const params = {
    bid: '5.1.1',
    time: yyyyMMddhhmmss(),
    pagename: 'ACT_D',
    unid: source,
    uuid: userInfo.uuid,
    act: 'vip',
    ftype: 5,
    clocation: clocation,
    actid: source,
    thirdid: 'other'
  };
  setTimeout(() => {
    axios.get("https://vip.log.mgtv.com/audit_all.html" + '?' + queryString.stringify(params));
  }, 0);
}

/**
 *
 * @param {*} clocation 页面不同入口
 * @param {*} productId 产品编号
 * @param {*} price  产品价格
 * @param {*} channel_id 渠道uuid
 * @param {*} order 订单号
 */
function appOrder(clocation, productId, price, channel_id, order,source,userInfo,deviceInfo) {
  const device_info = deviceInfo;
  const params = {
    pagename: 'Q',
    actid: source,
    uuid: userInfo.uuid,
    time: yyyyMMddhhmmss(),
    mod: device_info.mod,
    ch: device_info.ch,
    sver: device_info.sver,
    gps: device_info.gps,
    mf: device_info.mf,
    did: device_info.did,
    cid: device_info.cid,
    bid: '2.1.1',
    net: device_info.net,
    pver: device_info.pver,
    pix: device_info.pix,
    aver: device_info.aver,
    p: productId,
    pp: price,
    c: channel_id,
    o: order,
    act: 'order',
    isad: 0,
    mcc: 0,
    clocation: clocation,
    source: 'ACT_D',
    loginflag: 0,
    expver: "0"
  };
  setTimeout(() => {
    axios.get("https://vip.log.mgtv.com/audit_mpp.html" + '?' + queryString.stringify(params));
  }, 0);
}


/**
 *
 * @param {*} clocation 页面不同入口
 * @param {*} productId 产品编号
 * @param {*} price  产品价格
 * @param {*} channel_id 渠道uuid
 * @param {*} order 订单号
 */
function h5Order(clocation, productId, price, channel_id, order,source,userInfo) {
  const params = {
    bid: '5.1.1',
    time: yyyyMMddhhmmss(),
    pagename: 'ACT_D',
    unid: source,
    ftype: 5,
    clocation: clocation,
    uuid: userInfo.uuid,
    act: 'order',
    p: productId,
    pp: price,
    c: channel_id,
    o: order,
    sysport: gact.is_ott ? 1 : 2,
    thirdid: 'other',
    actid: source
  };
  setTimeout(() => {
    console.log("h5Order")
    axios.get("https://vip.log.mgtv.com/audit_all.html" + '?' + queryString.stringify(params));
  }, 0);
}


export function orderEvent(clocation, productId, price, channel_id, order,$vm) {
  console.log("orderEvent")
  const $vm_init ={
    urlParams:{},
    userInfo:{},
    deviceInfo:{}

  }
  $vm = $vm || $vm_init
  //统计信息
  const source= $vm.urlParams.source ||gact.source
  const userInfo= $vm.userInfo 
  const deviceInfo= $vm.deviceInfo

  if (isApp()) {
    console.log("orderEvent isApp")
    if (isAndroid()) {
      if (deviceInfo.appVersion > '5.7.3') {
        appOrder(clocation, productId, price, channel_id, order,source,userInfo,deviceInfo)
      }
    } else {
      appOrder(clocation, productId, price, channel_id, order,source,userInfo,deviceInfo)
    }
  } else {
    console.log("orderEvent h5")
    h5Order(clocation, productId, price, channel_id, order,source,userInfo)
  }
}

export function casherPV($vm) {
  const clocation = 1
  console.log("casherEvent")
  const $vm_init ={
    urlParams:{},
    userInfo:{},
    deviceInfo:{}

  }
  $vm = $vm || $vm_init
  //统计信息
  const source= $vm.urlParams.source ||gact.source
  const userInfo= $vm.userInfo 
  const deviceInfo= $vm.deviceInfo
  if (isApp()) {
    appCasherPV(clocation,source,userInfo,deviceInfo)
  } else {
    h5CasherPV(clocation,source,userInfo)
  }
}

export function error_event(event_name, data = {},source,userInfo,deviceInfo) {
  const params = {};
  params.uuid = userInfo.uuid || 'unknow';
  params.time = yyyyMMddhhmmss();
  params.act_name = window.rootdata.act_name_chn;
  params.source = source;
  params.uvip = userInfo.vip_id
  params.cookie = gact.analysis_id;
  params.type = 'event';
  params.info = event_name;
  params.mac = deviceInfo.mac || ""
  params.debug = window.gact.debug;
  params.invoker = window.gact.invoker;
  params.appVersion = deviceInfo.appVersion;
  params.platform = window.gact.platform;
  const _param = Object.assign({}, params, data);
  setTimeout(() => {
    axios.get("https:///vip.log.mgtv.com/vipact_event.html" + '?' + queryString.stringify(_param));
  }, 0);
}

//
// window.onerror = function (msg, url, line, col, error) {
//
//   //没有URL不上报！上报也不知道错误
//   // if (msg !== "Script error." && !url){
//   //   return true;
//   // }
//   //采用异步的方式
//   //我遇到过在window.onunload进行ajax的堵塞上报
//   //由于客户端强制关闭webview导致这次堵塞上报有Network Error
//   //我猜测这里window.onerror的执行流在关闭前是必然执行的
//   //而离开文章之后的上报对于业务来说是可丢失的
//   //所以我把这里的执行流放到异步事件去执行
//   //脚本的异常数降低了10倍
//   setTimeout(function () {
//     var data = {};
//     //不一定所有浏览器都支持col参数
//     col = col || (window.event && window.event.errorCharacter) || 0;
//
//     data.url = url;
//     data.line = line;
//     data.col = col;
//     if (!!error && !!error.stack) {
//       //如果浏览器有堆栈信息
//       //直接使用
//       data.msg = error.stack.toString();
//     } else {
//       data.msg = msg || 'unknow';
//     }
//     // else if (!!arguments.callee) {
//     //   //尝试通过callee拿堆栈信息
//     //   var ext = [];
//     //   var f = arguments.callee.caller, c = 3;
//     //   //这里只拿三层堆栈信息
//     //   while (f && (--c > 0)) {
//     //     ext.push(f.toString());
//     //     if (f === f.caller) {
//     //       break;//如果有环
//     //     }
//     //     f = f.caller;
//     //   }
//     //   ext = ext.join(",");
//     //   data.msg = error.stack.toString();
//     // }
//     //把data上报到后台！
//     console.error('全局捕获异常')
//     console.error(data)
//     if(window.gact.debug){
//       return;
//     }
//     error_event('全局捕获异常', data);
//   }, 0);
//
//   return true;
// };



// WEBPACK FOOTER //
// ./src/tools/mgtv/analysis.js